import { get } from 'lodash';

function skipMetaEtc(meta) {
  var isApiResponse = get(meta, 'previousAction.meta.apiRequest') != null;
  return isApiResponse;
}

export function createModalReducer(shownType, hiddenTypes) {
  var initialState = {
    modalIsShowing: false
  };

  if (!Array.isArray(hiddenTypes)) {
    hiddenTypes = [hiddenTypes];
  }

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

    var _ref = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref.type,
        error = _ref.error,
        meta = _ref.meta,
        payload = _ref.payload;

    if (type === shownType) {
      if (skipMetaEtc(meta)) {
        return {
          modalIsShowing: true
        };
      } else {
        return {
          modalIsShowing: true,
          error: error,
          payload: payload,
          meta: meta
        };
      }
    }

    if (hiddenTypes.includes(type)) {
      if (skipMetaEtc(meta)) {
        return {
          modalIsShowing: false
        };
      } else {
        return {
          modalIsShowing: false,
          error: error,
          payload: payload,
          meta: meta
        };
      }
    }

    return state;
  };
}
;
export function createModalSelector() {
  var getModalData = createModalDataSelector.apply(void 0, arguments);
  return function (state) {
    var md = getModalData(state);

    if (md == null) {
      return false;
    }

    return md.modalIsShowing;
  };
}
export function createModalDataSelector() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (state) {
    var data = get(state, args);
    return data == null ? {} : data;
  };
}